import React from "react";
import { useNavigate } from "react-router-dom";
import { Bell, ShoppingBag, Settings } from "lucide-react";
import { useAuth } from "../App";
import { useNotifications } from "../App";
import { useCart } from "../App";

const LOGO_URL = "/brand/colacicco-logo-nero.png";

const TopBar = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { unreadCount } = useNotifications();
  const { cartCount } = useCart();

  return (
    <header 
      className="fixed top-0 left-0 right-0 h-14 bg-black/80 backdrop-blur-md border-b border-white/5 flex items-center justify-between px-4 z-40"
      data-testid="top-bar"
    >
      {/* Logo */}
      <button 
        onClick={() => navigate("/")}
        className="h-8"
        data-testid="logo-button"
      >
        <img 
          src={LOGO_URL} 
          alt="Colacicco Legno" 
          className="h-full w-auto object-contain"
        />
      </button>

      {/* Actions */}
      <div className="flex items-center gap-4">
        {/* Cart */}
        <button 
          onClick={() => navigate("/cart")}
          className="relative text-white/70 hover:text-white transition-colors"
          data-testid="cart-button"
        >
          <ShoppingBag size={22} strokeWidth={1.5} />
          {cartCount > 0 && (
            <span className="absolute -top-1 -right-1 w-4 h-4 bg-emerald-500 text-black text-[10px] font-bold rounded-full flex items-center justify-center">
              {cartCount > 9 ? "9+" : cartCount}
            </span>
          )}
        </button>

        {/* Notifications */}
        <button 
          onClick={() => navigate("/notifications")}
          className="relative text-white/70 hover:text-white transition-colors"
          data-testid="notifications-button"
        >
          <Bell size={22} strokeWidth={1.5} />
          {unreadCount > 0 && (
            <span className="absolute -top-1 -right-1 w-4 h-4 bg-emerald-500 text-black text-[10px] font-bold rounded-full flex items-center justify-center">
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          )}
        </button>

        {/* Admin */}
        {user?.is_admin && (
          <button 
            onClick={() => navigate("/admin")}
            className="text-white/70 hover:text-emerald-500 transition-colors"
            data-testid="admin-button"
          >
            <Settings size={22} strokeWidth={1.5} />
          </button>
        )}
      </div>
    </header>
  );
};

export default TopBar;
